import src from "IMAGE";
export default { src, width: 414, height: 875, blurWidth: 4, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAAMElEQVR42m2NQQoAIAzD4tz8/5NV6GGUHXJJCQWIxxaJREoUtqaL6snndFFTEtjtuhzrAGxqknIDAAAAAElFTkSuQmCC"};
